import { css } from '@emotion/react';

import a11yHidden from '@lib/styles/a11yHidden';
import { palette } from '@lib/styles/palette';

const containerStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 85vw;
  max-width: 315px;
  min-width: 250px;
  height: auto;
  padding: 26px 0 0 0;
  box-sizing: border-box;
  background-color: ${palette.white};
  line-height: 20px;
  border-radius: 5px;
  text-align: center;

  & span.lineChange {
    display: block;
  }
`;

const buttonGroupStyle = css`
  display: flex;
  width: 100%;
  border-radius: 0 0 5px 5px;
  overflow: hidden;

  & > button:first-of-type {
    border-right: 1px solid ${palette.gray4};
  }
`;

const buttonStyle = css`
  width: 100%;
  margin-top: 26px;
  border: 0;
  border-radius: 0;
  border-top: 1px solid ${palette.gray4};
  padding: 14px 16px 18px;
  background: ${palette.white};
  font-size: min(4vw, 16px);
  color: ${palette.gray9};

  &:hover {
    color: ${palette.orange9};
  }
`;

export { containerStyle, a11yHidden, buttonGroupStyle, buttonStyle };
